export default __webpack_public_path__ + "static/media/hht2_ep11_book_wp_02.2c2c462a.jpg";